import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import CommissionInfo from '../../components/adminComponents/commission/commissionInfo/commissionInfo';
import LoadingProgress from '../../components/utilComponents/LoadingProgress';
import {
    getCommissionDetailRecord, 
    onCommissionDetailsFieldChange,
    onCommissionSave, 
    onCommissionChargesChange, 
    onCommissionDetailObjectChanged
} from '../../actions/adminAction/commissionActions';
import { getChargeList } from '../../actions/adminAction/ratePlanActions';
import { notify } from '../../util/notifications';
import { getAccessLevelsByModule } from '../../util/customMethods';

const DEFAULT_DRIVER_LEVEL_ID = 999; // Default driver level for simplified system

class CommissionRecPage extends Component {
    constructor() {
        super();
        this.state = {
            typeName: '',
            isLoading: false,
            loadingMessage: '',
            loadingProgress: 0
        };
    }

    componentDidMount() {
        const queryValues = queryString.parse(this.props.location.search);
        const typeId = queryValues.typeId;
        const typeName = queryValues.typeName || 'Commission Configuration';
        
        this.setState({ typeName });
        this.bindCommissionDetails(typeId);
    }

    checkViewAccess = (accessLevel = {}) => {
        if (accessLevel.basicAccess.view !== true) {
            this.props.history.push('/admin/notfound');
        }
    }

    // Loading state management methods
    setLoadingState = (isLoading, message = '', progress = 0) => {
        try {
            this.setState({
                isLoading,
                loadingMessage: message,
                loadingProgress: progress
            });
        } catch (error) {
            console.warn('Failed to set loading state:', error);
            this.setState({ isLoading });
        }
    }

    simulateProgress = (callback) => {
        this.setState({ loadingProgress: 25 });
        
        setTimeout(() => {
            this.setState({ loadingProgress: 50 });
        }, 200);
        
        setTimeout(() => {
            this.setState({ loadingProgress: 75 });
        }, 400);
        
        setTimeout(() => {
            this.setState({ loadingProgress: 100 });
            if (callback && typeof callback === 'function') {
                callback();
            }
        }, 600);
    }

    resetLoading = () => {
        this.setState({
            isLoading: false,
            loadingMessage: '',
            loadingProgress: 0
        });
    }

    bindCommissionDetails = async (typeId) => {
        this.typeId = typeId;
        const { dispatch } = this.props;
        
        this.setLoadingState(true, 'Loading commission details...', 30);
        
        try {
            await dispatch(getChargeList());
            await dispatch(getCommissionDetailRecord(typeId, DEFAULT_DRIVER_LEVEL_ID));
            
            this.setLoadingState(true, 'Commission details loaded successfully!', 100);
            
            setTimeout(() => {
                this.resetLoading();
            }, 800);
        } catch (error) {
            this.resetLoading();
            notify.createNotification('error', 'Failed to load commission details.', this.props.refNotify);
        }
    }

    handleSave = async (e, rec) => {
        rec.commissionTypeId = this.typeId;
        rec.driverLevelId = DEFAULT_DRIVER_LEVEL_ID; // Always use default
        
        this.setLoadingState(true, 'Saving commission configuration...', 0);
        
        this.simulateProgress(async () => {
            try {
                const res = await this.props.dispatch(onCommissionSave(rec));
                
                if (res.statusCode === 200) {
                    this.setLoadingState(true, 'Commission saved successfully! Redirecting...', 100);
                    notify.createNotification('success', res.statusMsg, this.props.refNotify);
                    
                    setTimeout(() => {
                        this.resetLoading();
                        this.props.history.push('/admin/commission');
                    }, 1000);
                } else {
                    this.resetLoading();
                    notify.createNotification('error', res.statusMsg, this.props.refNotify);
                }
            } catch (error) {
                this.resetLoading();
                notify.createNotification('error', 'An error occurred while saving the commission.', this.props.refNotify);
            }
        });
    }

    render() {
        const accessLevelObj = getAccessLevelsByModule('Commission');
        this.checkViewAccess(accessLevelObj);
        
        document.title = `Configure Commission - ${this.state.typeName}`;

        return (
            <Fragment>
                <div className="page-header">
                    <div className="row mb-10">
                        <div className="col-md-12 col-sm-12">
                            <div className="title">
                                <h4>
                                    <i className="fa fa-money"></i> Configure Commission: {this.state.typeName}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Loading Progress Indicator */}
                <LoadingProgress 
                    isLoading={this.state.isLoading}
                    message={this.state.loadingMessage}
                    progress={this.state.loadingProgress}
                />
                
                <div 
                    className="pd-10 bg-white border-radius-4 box-shadow container-box"
                    style={{ 
                        opacity: this.state.isLoading ? 0.7 : 1, 
                        pointerEvents: this.state.isLoading ? 'none' : 'auto' 
                    }}
                >
                    <CommissionInfo 
                        commissionRec={this.props.commission.commissionDetailObj}
                        userDefaultCharges={this.props.commission.commissionDetailObj.userDefaultCharges}
                        accessLevel={accessLevelObj || {}}
                        hideDriverLevel={true}
                        disabled={this.state.isLoading}
                        onCommissionChargesChange={(key, list) => {
                            this.props.dispatch(onCommissionChargesChange(key, list));
                        }}
                        onUpdateCommissionCharge={(commissionObj) => {
                            this.props.dispatch(onCommissionDetailObjectChanged(commissionObj));
                        }}
                        onCommissionInfoFieldValueChange={(key, value) => {
                            this.props.dispatch(onCommissionDetailsFieldChange(key, value));
                        }}
                        onSubmitCommissionRec={this.handleSave}
                    />
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        refNotify: state.refNotify,
        commission: state.commission
    };
};

export default withRouter(connect(mapStateToProps)(CommissionRecPage));